"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _SubscriptionEmailTypes = require("./SubscriptionEmailTypes");

var getUrlByType = function getUrlByType(type) {
  return "cosemail/v1/subscription-emails/" + type + "/get";
};

var createUrlByType = function createUrlByType(type) {
  return "cosemail/v1/subscription-emails/" + type + "/get-or-create";
};

var SubscriptionEmailsAPI =
/*#__PURE__*/
function () {
  function SubscriptionEmailsAPI() {
    (0, _classCallCheck2.default)(this, SubscriptionEmailsAPI);
  }

  (0, _createClass2.default)(SubscriptionEmailsAPI, null, [{
    key: "getOptinEmail",
    value: function getOptinEmail() {
      return _apiClient.default.get(getUrlByType(_SubscriptionEmailTypes.OPTIN_EMAIL));
    }
  }, {
    key: "createOptinEmail",
    value: function createOptinEmail(isDragDrop) {
      return _apiClient.default.get(createUrlByType(_SubscriptionEmailTypes.OPTIN_EMAIL), {
        query: {
          isDragDrop: isDragDrop
        }
      });
    }
  }, {
    key: "getOptinFollowupEmail",
    value: function getOptinFollowupEmail() {
      return _apiClient.default.get(getUrlByType(_SubscriptionEmailTypes.OPTIN_FOLLOWUP_EMAIL));
    }
  }, {
    key: "createOptinFollowupEmail",
    value: function createOptinFollowupEmail(isDragDrop) {
      return _apiClient.default.get(createUrlByType(_SubscriptionEmailTypes.OPTIN_FOLLOWUP_EMAIL), {
        query: {
          isDragDrop: isDragDrop
        }
      });
    }
  }, {
    key: "getResubscribeEmail",
    value: function getResubscribeEmail() {
      return _apiClient.default.get(getUrlByType(_SubscriptionEmailTypes.RESUBSCRIBE_EMAIL));
    }
  }, {
    key: "createResubscribeEmail",
    value: function createResubscribeEmail(isDragDrop) {
      return _apiClient.default.get(createUrlByType(_SubscriptionEmailTypes.RESUBSCRIBE_EMAIL), {
        query: {
          isDragDrop: isDragDrop
        }
      });
    }
  }]);
  return SubscriptionEmailsAPI;
}();

exports.default = SubscriptionEmailsAPI;
module.exports = exports.default;